module.exports={render:function (){with(this) {
  return _h('div', [_m(0), " ", _m(1), " ", _h('div', {
    staticClass: "audio-warning"
  }, [_h('div', {
    staticClass: "audio-warning__icon",
    domProps: {
      "innerHTML": _s(image.speaker)
    }
  }), " ", _m(2)]), " ", (!audioPlayer.loaded) ? _h('div', {
    staticClass: "loading-bar"
  }, [_h('div', {
    staticClass: "loading-bar-inner",
    style: (("width:" + (audioPlayer.loadedAmount * 100) + "%;"))
  })]) : _e(), " ", (audioPlayer.loaded) ? _h('div', {
    staticClass: "start-button"
  }, [_h('find-button', {
    on: {
      "click": function($event) {
        setPage(PAGE_GAME)
      }
    }
  }, ["\n      Start Game\n    "])]) : _e(), " ", _m(3)])
}},staticRenderFns: [function (){with(this) {
  return _h('h1', ["Find the Invisible Cow"])
}},function (){with(this) {
  return _h('p', ["Move your cursor around to find the cow. It’s hiding behind the shouting."])
}},function (){with(this) {
  return _h('p', {
    staticClass: "auto-warning__text"
  }, ["Make sure you turn your audio on before playing."])
}},function (){with(this) {
  return _h('p', {
    staticClass: "note"
  }, ["\n    If you do not hear anything, it’s possible that your browser does not support the Web Audio\n    API. Currently supported browsers are\n    ", _h('a', {
    attrs: {
      "href": "http://google.com/chrome",
      "target": "_blank"
    }
  }, ["Chrome 10+"]), ",\n    ", _h('a', {
    attrs: {
      "href": "http://www.mozilla.org/en-US/firefox/new/",
      "target": "_blank"
    }
  }, ["Firefox 25+"]), ",\n    ", _h('a', {
    attrs: {
      "href": "http://www.opera.com/",
      "target": "_blank"
    }
  }, ["Opera 15+"]), ", and\n    ", _h('a', {
    attrs: {
      "href": "http://www.apple.com/au/safari/",
      "target": "_blank"
    }
  }, ["Safari 6+"]), ".\n  "])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-322c5372!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
 ** module id = 166
 ** module chunks = 2
 **/